import { TextField, Typography } from "@mui/material";
import moment from "moment";
import React, { useState } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "underscore";
import { updateProfile } from "../../redux/action";
import { PROFILE } from "../../redux/constant";

import {
  CustomButton,
  CustomInput,
  DefaultLoader,
  StepLabel,
} from "../../../components";

import { allowedIdType } from "../../../utils/allowedIdType";
import { gatherIdentities } from "../../../utils/functions/gatherIdentities";
import styles from "../styles";

const TextArea = props => (
  <textarea
    {...props}
    style={{
      fontSize: "16px",
      lineHeight: "1.4375em",
      padding: "16.5px 14px",
      minHeight: "88px", // mimics 4 rows
      resize: "vertical",
      border: "none",
      outline: "none",
      width: "100%",
      boxSizing: "border-box",
    }}
  />
);

const UpdateVC = props => {
  const { loading, profile, updateProfile, history } = props;

  const [{ isVc, vcDescription }, setQuestion] = useState({
    isVc: profile?.isVc ? "Yes" : "No",
    vcDescription: profile?.vcDescription || "",
  });

  const vcDescriptionExceedMaxLength = vcDescription.length > 100;
  const vcDescriptionLessThanMinLength = vcDescription.length < 3;

  const [formStatus, setFormStatus] = React.useState("idle");

  const isVcYesButVcDescriptionIsBlank = isVc === "Yes" && vcDescription === "";

  const localIdentity = profile?.identities?.find(allowedIdType);

  const handleUpdate = () => {
    setFormStatus("submitting");

    if (
      (isVc === "Yes" &&
        (vcDescriptionExceedMaxLength ||
          vcDescriptionLessThanMinLength ||
          (profile?.isVc && vcDescription === profile?.vcDescription))) ||
      (isVc === "No" && !profile?.isVc)
    )
      return;

    const payload = {
      masterId: profile?.masterId, //R
      email: profile?.email, //R
      mobileNo: profile?.mobileNo, //R
      fullName: profile?.fullName, //R
      townOfBirth: profile?.townOfBirth, //R
      dob: moment(profile?.dob).format("YYYY-MM-DD"), //R
      race: profile?.race, //R
      natureOfBusinessCd: profile?.natureOfBusinessCd, //R
      occupationTypeCd: profile?.occupationTypeCd, //R
      maritalStatusCd: profile?.maritalStatusCd, //R
      yearlyIncomeLevelCd: profile?.yearlyIncomeLevelCd, //R
      sourceOfFundCd: profile?.sourceOfFundCd,
      investmentObjCd: profile?.investmentObjCd,
      employerName: profile?.employerName,
      isVc: isVc === "Yes",
      optIn: Boolean(profile?.optIn),
      identities: gatherIdentities(profile, localIdentity),
      address: {
        line1: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line1, //R
        line2: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line2,
        line3: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line3,
        postCode: profile?.contacts.find(contact => contact.postCode).postCode, //R
        city: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).city,
        state: profile?.contacts.find(contact => contact.state).state, //R,
        country: localIdentity?.citizenship,
      },
    };

    if (isVc === "Yes") {
      payload.vcDescription = vcDescription;
    }

    updateProfile({ payloadData: payload, from: PROFILE }, () => {
      setFormStatus("idle");
    });
  };

  return (
    <div style={{ backgroundColor: "#fff", ...styles.container }}>
      {loading && <DefaultLoader />}
      <StepLabel
        title="Vulnerable client"
        onClick={() => history.back()}
        containerStyles={{ margin: "16px 16px 22px" }}
      />
      <form style={{ margin: "16px 16px 0 16px" }}>
        <CustomInput
          label="Are you a vulnerable client?"
          name="isVc"
          value={isVc}
          onChange={e => {
            const value = e.target.value;
            setQuestion(prev => ({ ...prev, isVc: value }));
            setFormStatus("idle");
          }}
          isEdit={true}
          isRequired={false}
          isRadio={true}
        />
        {isVc === "Yes" && (
          <>
            <Typography
              color="textPrimary"
              style={{
                fontWeight: "700",
                fontSize: "14px",
                lineHeight: 1.57,
                marginBottom: "8px",
              }}
            >
              Description
            </Typography>
            <TextField
              name="vcDescription"
              type="text"
              variant="outlined"
              placeholder="Add short description to explain your vulnerability here"
              onChange={e => {
                const filtered = e.target.value.replace(
                  /[^a-zA-Z0-9.,!?:;'"()\-\n ]/g,
                  ""
                );
                setQuestion(prev => ({ ...prev, vcDescription: filtered }));
              }}
              value={vcDescription}
              error={
                formStatus === "submitting" &&
                (isVcYesButVcDescriptionIsBlank ||
                  vcDescriptionExceedMaxLength ||
                  vcDescriptionLessThanMinLength)
              }
              helperText={
                formStatus === "submitting" &&
                (isVcYesButVcDescriptionIsBlank
                  ? "This field is required"
                  : vcDescriptionLessThanMinLength
                  ? "Minimum 3 characters"
                  : vcDescriptionExceedMaxLength && "Maximum 100 characters")
              }
              InputProps={{
                inputComponent: TextArea,
              }}
              inputProps={{
                style: {
                  fontFamily: "FSElliotPro",
                },
              }}
              fullWidth
              style={{ marginBottom: "14px" }}
            />
          </>
        )}

        <div style={styles.btnContainer}>
          <CustomButton
            text="Save"
            variant="contained"
            color="#fff"
            backgroundColor="#1278CC"
            onClick={handleUpdate}
          />
        </div>
      </form>
    </div>
  );
};

const withConnect = connect(
  state => ({
    loading: state.goal.loading,
    isModalOpen: state.goal.isModalOpen,
    errorMessage: state.goal.errorMessage,
    profile: state.goal.profile,
  }),
  {
    updateProfile,
  }
);

export default compose(
  withRouter,
  withConnect
)(UpdateVC);
